import * as React from 'react';
import {Reporter} from '../core/reporter';
import {AnalyticsContext} from './createAnalyticsContext';

export const createAnalyticsProvider = <T extends string>(
  analyticsReporter: Reporter<T>,
  Context: React.Context<AnalyticsContext<T>>,
) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const Provider = Context.Provider as any;

  return ({children}: {children: React.ReactNode}) => {
    return <Provider value={{analyticsReporter}}>{children}</Provider>;
  };
};
